export default __webpack_public_path__ + "static/media/ParentsGuidetoScouts.ab351e35.pdf";